import React, { Component } from "react";

import AddIcon from '@material-ui/icons/Add';
import Tooltip from '@material-ui/core/Tooltip';
import OrderedRaterList from './OrderedRaterList.js';

class RaterRow extends Component {
	constructor() {
		super();
		this.handleAdd = this.handleAdd.bind(this);
		this.deleteUser = this.deleteUser.bind(this);
		this.addUser = this.addUser.bind(this);
	}
	
	handleAdd() {
		this.props.addUser(this.props.id);
	}
	
	deleteUser(){
	}
	
	addUser(){
	}
	
	render() {
		//let userList = "";
		//if( (typeof(this.props.users) != "undefined") && (this.props.users.length>0) ){
		//	userList = this.props.users.reduce((acc, cur) => (typeof(cur.user) != "undefined") ? acc+cur.user.username+", " : acc, "");
		//}
		return (
			<tr key={this.props.key}>
			<td>{this.props.id}</td>
			<td>{this.props.langPair.code}</td>
			<td>
				<OrderedRaterList
					raters={this.props.users}
					handleMorePriority={this.props.handleMorePriority}
				/>
			</td>
			<td><Tooltip title="Add"><AddIcon style={{ fontSize: "21px", color: "#000", cursor: "pointer"}} onClick={() => { this.handleAdd(); }}  /></Tooltip></td>
			</tr>
		);
	}
}

export default RaterRow;